import { createFileRoute } from "@tanstack/react-router";

import TaskDetailSidebar from "@/components/TaskDetailSidebar/TaskDetailSidebar";

const Component = () => {
  const uuid = Route.useParams().taskUuid;
  return <TaskDetailSidebar uuid={uuid} />;
};

export const Route = createFileRoute("/gym/$venueUuid/schedule/set/$setUuid/$taskUuid")({
  component: Component,
});
